export const PlatformEnv = {
  STAGING: 'staging',
  PRODUCTION: 'prod',
} as const;

export const PlatformEnvFilter = {
  ALL: 'All-envs',
  ...PlatformEnv,
} as const;

export const IntegrationAction = {
  HISTORICAL_UPLOAD: 'historical_data:::upload_data',
  HISTORICAL_SETUP: 'historical_data:::setup_daily_uploads',
  RECS_GET: 'integrate_recs:::get_api_access',
  RECS_SELECT: 'integrate_recs:::select_sections',
  RECS_INTEGRATE: 'integrate_recs:::integrate_api',
  RECS_VALIDATE: 'integrate_recs:::validate_integration',
  FEEDBACK_SETUP: 'send_feedback:::setup_sending_feedback',
  FEEDBACK_VALIDATE: 'send_feedback:::validate_feedback',
} as const;

export const IntegrationStatus = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
  NOT_ACTUAL: 'not_actual',
} as const;

export const PlatformStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  INTEGRATION: 'integration',
} as const;

export const BrandStatus = {
  INACTIVE: 'inactive',
  AB_TESTING: 'ab-testing',
  INTEGRATION: 'integration',
  INTEGRATION_DONE: 'integration-done',
  RECS_FOR_ALL: 'recs-for-all',
} as const;

export const UploadedFileStatus = {
  SUCCESS: 'passed',
  ERROR: 'failed',
  PENDING: 'pending',
  MISSING: 'missing',
} as const;

export const UploadedFileSeverity = {
  SUCCESS: 'passed',
  WARNING: 'warning',
  CRITICAL: 'critical',
} as const;
